import React from "react"
import { Stack, Typography } from "@mui/material"
import { GenericIconLabel } from "../../../components/generic/GenericIconLabel"
import { PencilSimpleLine } from "@phosphor-icons/react"

export const EditHeader = ({ label, action, ...others }) => {
  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} {...others}>
      <Typography className="subTitle">{label}</Typography>
      <GenericIconLabel
        onClick={() => action()}
        typographyProps={{ fontWeight: 700 }}
        color={'primary.main'}
        label={'Edit'}
        icon={<PencilSimpleLine size={16} weight="bold" />}
        sx={{
          cursor: 'pointer'
        }}
      />
    </Stack>
  )
};